import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import logo from './Img/ThakurCapital.png';
import './Footer.css';

const Footer = () => (
  <footer className="site-footer">
    <div className="container site-footer__container">
      <div className="site-footer__main">
        <section className="site-footer__brand">
          <Link to="/" aria-label="Thakur Capital home"><img src={logo} alt="Thakur Capital" /></Link>
          <p>Practical stock-market education designed to help you invest with clarity and confidence.</p>
          <div className="site-footer__socials" aria-label="Social media links">
            <a href="https://facebook.com/thakurcapital" target="_blank" rel="noreferrer" aria-label="Facebook"><FaFacebookF /></a>
            <a href="https://twitter.com/thakurcapital" target="_blank" rel="noreferrer" aria-label="Twitter"><FaTwitter /></a>
            <a href="https://linkedin.com/company/thakurcapital" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://instagram.com/thakurcapital" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram /></a>
          </div>
        </section>

        <section className="site-footer__links">
          <h2>Explore</h2>
          <Link to="/">Home</Link>
          <Link to="/about">About us</Link>
          <Link to="/courses">Our programs</Link>
          <Link to="/contact">Contact us</Link>
        </section>

        <section className="site-footer__contact">
          <h2>Get in touch</h2>
          <a href="tel:+919867545497">+91 98675 45497</a>
          <a href="mailto:contact@thakurcapital.com">contact@thakurcapital.com</a>
          <address>Shop No. 116, Shalimar Miracle, Road No. 4, next to Bank of India, Jawahar Nagar, Goregaon West, Mumbai – 400104</address>
        </section>
      </div>

      <div className="site-footer__bottom">
        <span>© {new Date().getFullYear()} Thakur Capital. All rights reserved.</span>
        <div><Link to="/privacy-policy">Privacy Policy</Link><Link to="/terms-conditions">Terms &amp; Conditions</Link></div>
      </div>
    </div>
  </footer>
);

export { Footer };
